import { StateCreator } from 'zustand';
import { CaseVersion } from '../../../shared';

export interface CompareTreatmentsSlice {
  isCompareTreatmentsActivated: boolean;
  currentVersion: CaseVersion | null;
  versionToCompare: CaseVersion | null;
  setIsCompareTreatmentsActivated: (isCompareTreatmentsActivated: boolean) => void;
  setVersionToCompare: (versionToCompare: CaseVersion | null) => void;
  setCurrentVersion: (currentVersion: CaseVersion) => void;
  isVersionLoaded: boolean;
  setIsVersionLoaded: (isVersionLoaded: boolean) => void;
}

export const createCompareTreatmentsSlice: StateCreator<CompareTreatmentsSlice, [], [], CompareTreatmentsSlice> = (
  set
) => ({
  isCompareTreatmentsActivated: false,
  versionToCompare: null,
  currentVersion: null,
  setIsCompareTreatmentsActivated: (isCompareTreatmentsActivated: boolean) =>
    set((_) => ({ isCompareTreatmentsActivated })),
  setVersionToCompare: (versionToCompare: CaseVersion | null) => set((_) => ({ versionToCompare })),
  setCurrentVersion: (currentVersion: CaseVersion) => set((_) => ({ currentVersion })),
  isVersionLoaded: false,
  setIsVersionLoaded: (isVersionLoaded: boolean) => set((_) => ({ isVersionLoaded }))
});
